import { useRef, useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import {
  TypographyElement,
  Icon,
  Icons,
  Paper
} from 'UI'
import Text from './text.json'

const useStyle = createUseStyles(style)

const maxItems = 2

export default ({ ConcernedAudiences = [], margin, noPaper }) => {
  const theme = useTheme()
  const [open, setOpen] = useState(!(ConcernedAudiences?.length > maxItems))
  const ref = useRef()
  const { concernedAudiencesGroup, concernedAudiencesText, icon, iconCheck, concernedAudienceItem, showMore } = useStyle({ open, margin, noPaper })
  const Component = noPaper ? 'div' : Paper
  return (
    ConcernedAudiences.length
      ? (
        <Component noHover className={concernedAudiencesGroup}>
          <TypographyElement
            variant='heading2'
            spacing='0 0 24px 0'
            Component='h2'
          >
            {Text.title}
          </TypographyElement>
          <div>
            <div className={concernedAudiencesText} style={{ height: open ? ref?.current?.clientHeight : 60 }}>
              <div ref={ref}>
                {
                  ConcernedAudiences.map((prerequirement, key) => (
                    <div key={key} className={concernedAudienceItem}>
                      <TypographyElement
                        variant='body1'
                      >
                        <Icon iconName={Icons.check} style={iconCheck} />
                        {prerequirement}
                      </TypographyElement>
                    </div>
                  ))
                }
              </div>
            </div>
            {
              ConcernedAudiences.length > maxItems && (
                <TypographyElement
                  variant='button'
                  color={theme.primary[0]}
                  cursor='pointer'
                  handleClick={() => setOpen(!open)}
                  display='flex'
                  className={showMore}
                  spacing='30px 0 0 0'
                >
                  {open ? Text.showLess : Text.showMore}<Icon iconName={open ? Icons.roundedUp : Icons.roundedDown} style={icon} />
                </TypographyElement>)
            }
          </div>
        </Component>
        )
      : null
  )
}
